import styled from 'styled-components'
import { limitLines } from 'src/styles'
import { UserAvatar } from 'src/components/userAvatar'

type MentionItemProps = {
  $isSelected?: boolean
}

export const MentionEmptyText = styled.span`
  display: block;
  min-height: 3.125rem;
`

MentionEmptyText.displayName = 'MentionEmptyText'

export const MentionItemWrapper = styled.div`
  height: 5rem;
`

MentionItemWrapper.displayName = 'MentionItemWrapper'

export const MentionImage = styled(UserAvatar)`
  width: 3rem;
  height: 3rem;
`

MentionImage.displayName = 'MentionImage'

export const TextWrapper = styled.div`
  max-width: 13rem;
`

TextWrapper.displayName = 'TextWrapper'

export const MentionText = styled.span`
  ${limitLines(2)}
`

MentionText.displayName = 'MentionText'

export const MentionReference = styled.span`
  text-overflow: ellipsis;
`

MentionReference.displayName = 'MentionReference'

export const MentionItem = styled.button<MentionItemProps>`
  background-color: ${({ $isSelected }) => ($isSelected ? 'var(--gray-100)' : 'transparent')};
  transition: background-color 0.2s;
  outline-offset: -2px;

  ${MentionImage} {
    transition: filter 0.2s;
  }

  &:hover {
    background-color: var(--gray-200);

    ${MentionImage} {
      filter: contrast(0.85);
    }
  }
`
MentionItem.displayName = 'MentionItem'
